import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "winlossControls", "placementControls", "recordStyleSelect", "recordStyleHiddenInput" ]

  connect() {
    // console.log("Hello, Entity Game Basics Controller here!", this.element);
    // console.log(this.winlossControlsTarget);
    // console.log(this.placementControlsTarget);

    let recordStyleTarget = null;
    if (this.hasRecordStyleSelectTarget) {
      recordStyleTarget = this.recordStyleSelectTarget;
    } else if (this.hasRecordStyleHiddenInputTarget) {
      recordStyleTarget = this.recordStyleHiddenInputTarget;
    } else {
      console.error("No record style target found");
      return;
    }

    this.toggleControls({ target: recordStyleTarget });
  }

  toggleControls(event) {

    // console.log("toggleControls");
    // console.log(event.target.value);

    if (event.target.value === "winloss") {

      this.winlossControlsTarget.classList.remove('d-none');
      this.winlossControlsTarget.classList.add('d-block');
      this.winlossControlsTarget.querySelectorAll('.required').forEach(elm => {
        elm.setAttribute('required', true);
        elm.removeAttribute('disabled');
      });

      this.placementControlsTarget.classList.remove('d-block');
      this.placementControlsTarget.classList.add('d-none');
      this.placementControlsTarget.querySelectorAll('.required').forEach(elm => {
        elm.removeAttribute('required');
        elm.setAttribute('disabled', true);
      });

    } else if (event.target.value === "placement") {

      this.winlossControlsTarget.classList.remove('d-block');
      this.winlossControlsTarget.classList.add('d-none');
      this.winlossControlsTarget.querySelectorAll('.required').forEach(elm => {
        elm.removeAttribute('required');
        elm.setAttribute('disabled', true);
      });

      this.placementControlsTarget.classList.remove('d-none');
      this.placementControlsTarget.classList.add('d-block');
      this.placementControlsTarget.querySelectorAll('.required').forEach(elm => {
        elm.setAttribute('required', true);
        elm.removeAttribute('disabled');
      });

    }

  }

}

